import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from 'apps/t2c-fe/utils';

export const getUploadedData = async (uploadId: string) => {
  return axiosInstance.get(`/api/uploads/${uploadId}`).then((res) => res.data);
};

export function useFetchUploadId() {
  return useMutation(getUploadedData, {
    onSuccess: (data) => data,
  });
}
